module.exports = __webpack_public_path__ + "static/media/bg_vestibular.5d779acd.jpeg";